import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "bg-white max-w-[600px] w-80 lg:w-96 border rounded shadow-lg absolute right-[-42px] lg:right-0 top-8 max-h-96 overflow-y-scroll flex flex-col gap-2"
}
const _hoisted_3 = { class: "flex justify-between px-5 py-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", { class: "font-bold" }, "Notificaciones", -1)
const _hoisted_5 = { class: "text-black text-sm p-5" }
const _hoisted_6 = { class: "flex justify-between items-baseline px-5 pb-5" }
const _hoisted_7 = { class: "text-sm font-light" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", { class: "text-left uppercase text-sm px-5" }, "Notificaciones leidas", -1)
const _hoisted_10 = { class: "text-sm text-gray-600 p-5" }
const _hoisted_11 = { class: "text-sm flex justify-between items-baseline px-5 pb-5" }
const _hoisted_12 = { class: "font-light text-sm" }

import { onMounted, onUnmounted, ref, watch } from "vue";
import { NotificationServices } from "@/services/notifications/NotificationServices";
import { Notification } from "@/services/notifications/types";
import { reformatDate } from "@/services/utils";
import { computed } from "@vue/reactivity";


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationMenu',
  emits: ["onClose"],
  setup(__props, { emit }) {



const notificationServices = new NotificationServices();
const notifications = ref<Notification[]>([]);
const unreadNotifications = computed(() =>
  notifications.value.filter((notification) => !notification.isReadAdmin)
);
const readedNotifications = computed(() =>
  notifications.value.filter((notification) => notification.isReadAdmin)
);
const notificationIconName = computed(() =>
  unreadNotifications.value.length > 0 ? "bell-badge" : "bell"
);

const menuIsVisible = ref(false);
const openingMenu = ref(false);

function showMenu() {
  menuIsVisible.value = true;
}

function closeMenu() {
  menuIsVisible.value = false;
}

onMounted(() => {
  addEventListener("keyup", onPressEsc);
});

onUnmounted(() => {
  removeEventListener("keyup", onPressEsc);
});

function onPressEsc(event: KeyboardEvent) {
  if (event.key == "Escape") {
    closeMenu();
  }
}

function clickOutside() {
  if (!openingMenu.value) {
    closeMenu();
  }
}

async function sendReadNotification(notificationId: number) {
  const response = await notificationServices.readNotification(notificationId);
  if (!response.success) {
    console.error("No se ha podido establecer como leida la notificaion");
    return;
  }
  fetchNotifications();
}

async function sendReadAllNotifications() {
  const response = await notificationServices.readAllNotifications();
  if (!response.success) {
    console.error(
      "No se ha podido establecer como leidas todas las notificaciones"
    );
    return;
  }
  fetchNotifications();
}

async function fetchNotifications() {
  const response = await notificationServices.getNotifications();

  if (!response.success) {
    console.error("No se ha podido obtener la lista de notificaciones");
    return;
  }

  notifications.value = response.data;
  notifications.value = notifications.value.map((notification) => {
    let newNotificationMessage = notification.message.split("<br>").join("");
    return { ...notification, message: newNotificationMessage };
  });
}

fetchNotifications();

watch(menuIsVisible, (newValue) => {
  if (!newValue) {
    emit("onClose");
  } else {
    openingMenu.value = true;
    setTimeout(() => {
      openingMenu.value = false;
    }, 500);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_mdicon, {
      class: "cursor-pointer hover:text-light-green text-white",
      name: _unref(notificationIconName),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showMenu()))
    }, null, 8, ["name"]),
    (menuIsVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (sendReadAllNotifications()))
            }, "Marcar todas leidas")
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(unreadNotifications), (notification, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "text-left hover:bg-[#9BB44157]"
            }, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(notification.message), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(reformatDate)(notification.createdAt)), 1),
                _createElementVNode("span", {
                  class: "bg-primary-green px-2 py-0.5 rounded-full font-bold text-white text-xs uppercase hover:bg-primary-green/80 cursor-pointer",
                  onClick: ($event: any) => (sendReadNotification(notification.id))
                }, " Nuevo ", 8, _hoisted_8)
              ])
            ]))
          }), 128)),
          _hoisted_9,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(readedNotifications), (notification, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "text-left text-gray-400 hover:bg-[#9BB44157]"
            }, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(notification.message), 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(reformatDate)(notification.createdAt)), 1)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_outside, clickOutside]
  ])
}
}

})